export default __webpack_public_path__ + "static/media/pantry1-afterE-768w.093c076e.png";